// extracted by mini-css-extract-plugin
export default {"container":"divider_container__fMRHt","vertical":"divider_vertical__a+1kj"};